import { render, staticRenderFns } from "./AccessTypeForm.vue?vue&type=template&id=632ee310&scoped=true"
import script from "./AccessTypeForm.vue?vue&type=script&lang=js"
export * from "./AccessTypeForm.vue?vue&type=script&lang=js"
import style0 from "./AccessTypeForm.vue?vue&type=style&index=0&id=632ee310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632ee310",
  null
  
)

export default component.exports